import React from 'react'

const UsecaseDesigners = ({ style = {}, ...props }) => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>usecase-designers</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="100%"
          x2="50%"
          y2="3.061617e-15%"
          id="linearGradient-1">
          <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
          <stop stopColor="#FFFFFF" offset="100%" />
        </linearGradient>
        <path
          d="M10.2555408,-4.14336123e-16 L21.7444592,4.14336123e-16 C25.3105342,-2.4074122e-16 26.6036791,0.371302445 27.9073828,1.06853082 C29.2110865,1.76575919 30.2342408,2.78891348 30.9314692,4.09261719 C31.6286976,5.39632089 32,6.68946584 32,10.2555408 L32,21.7444592 C32,25.3105342 31.6286976,26.6036791 30.9314692,27.9073828 C30.2342408,29.2110865 29.2110865,30.2342408 27.9073828,30.9314692 C26.6036791,31.6286976 25.3105342,32 21.7444592,32 L10.2555408,32 C6.68946584,32 5.39632089,31.6286976 4.09261719,30.9314692 C2.78891348,30.2342408 1.76575919,29.2110865 1.06853082,27.9073828 C0.371302445,26.6036791 1.60494146e-16,25.3105342 -2.76224082e-16,21.7444592 L2.76224082e-16,10.2555408 C-1.60494146e-16,6.68946584 0.371302445,5.39632089 1.06853082,4.09261719 C1.76575919,2.78891348 2.78891348,1.76575919 4.09261719,1.06853082 C5.39632089,0.371302445 6.68946584,2.4074122e-16 10.2555408,-4.14336123e-16 Z"
          id="path-2"
        />
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="Group-12" transform="translate(0, -125)">
          <g id="Group-10" transform="translate(0, 124)">
            <g id="usecase-designers" transform="translate(0, 1)">
              <g id="Rectangle">
                <use fill="#16A5F3" xlinkHref="#path-2" />
                <use
                  fillOpacity="0.15"
                  fill="url(#linearGradient-1)"
                  xlinkHref="#path-2"
                />
              </g>
              <path
                d="M9.32622862,12.2166829 L7.07656563,21.5288313 C6.90546249,22.2453147 7.02368976,23.000349 7.40562081,23.630275 L12.5026184,18.5344418 C12.078653,17.6493287 12.3544563,16.5875675 13.1556272,16.0205506 C13.9567982,15.4535337 15.0500978,15.5463325 15.7441907,16.2402669 C16.4382837,16.9342013 16.5311037,18.0272511 15.9639573,18.828239 C15.3968108,19.6292269 14.3348069,19.9049672 13.4494915,19.4810986 L8.35249389,24.5836456 C8.98250394,24.9718679 9.74061147,25.0949719 10.4611332,24.9260534 L19.7754095,22.6769044 L20.7222826,15.0835087 L16.9213595,11.2700262 L9.32622862,12.2166829 Z M18.3517422,7 L16.9213595,9.36999882 L22.6227442,15.070081 L25,13.6467389 L18.3517422,7 Z"
                id="Shape"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default UsecaseDesigners
